import api from "./api";

const ASKED_KEY = "push-notification-asked";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const getToken = () => {
  try {
    return localStorage.getItem("token");
  } catch (error) {
    return null;
  }
};

export const registerPushNotifications = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

  const token = getToken();
  if (!token) return;

  const asked = localStorage.getItem(ASKED_KEY) === "true";
  const permission = Notification.permission;
  if (permission === "denied") return;
  if (permission === "default" && asked) return;

  if (permission === "default") {
    localStorage.setItem(ASKED_KEY, "true");
    const permissionResult = await Notification.requestPermission();
    if (permissionResult !== "granted") return;
  }

  const { data } = await api.get("/push/public-key");
  const publicKey = data?.publicKey;
  if (!publicKey) return;

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
  }

  await api.post(
    "/push/subscribe",
    {
      endpoint: subscription.endpoint,
      keys: subscription.toJSON().keys,
      userAgent: navigator.userAgent,
      device: /iPhone|iPad|iPod/i.test(navigator.userAgent)
        ? "ios"
        : /Android/i.test(navigator.userAgent)
          ? "android"
          : "web"
    },
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};
